import React, { useEffect, useRef } from "react";
import moment from "moment";
import { d3 } from "../../adapter";

// Multi-series line chart over a shared time axis, with each meta series
// plotted on its own y-scale. D3 v3 implementation replacing the previous
// Chart.js v2 version.
const AllBrush = ({ station }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !station || !station.graph.length) return undefined;

    const margin = { top: 10, right: 70, bottom: 30, left: 70 };
    const width = Math.max(el.clientWidth || 600, 600) - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    d3.select(el).selectAll("*").remove();

    const svg = d3
      .select(el)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const timestamps = station.graph[0].map((d) => d.timestamp);
    const xScale = d3.time.scale().domain(d3.extent(timestamps)).range([0, width]);

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3.svg
          .axis()
          .scale(xScale)
          .orient("bottom")
          .ticks(6)
          .tickFormat((d) => moment(d).format("D-MM-YY"))
      );

    station.meta.forEach((meta, i) => {
      const series = station.graph[i];
      const values = station.chartdata[i];
      const yScale = d3.scale.linear().domain(d3.extent(values)).nice().range([height, 0]);

      // Only draw axis once per distinct yaxis id, alternating left/right.
      const axisOrient = i === 0 ? "left" : "right";
      svg
        .append("g")
        .attr("class", `y axis y-${meta.yaxis || i}`)
        .attr("transform", axisOrient === "right" ? `translate(${width},0)` : "translate(0,0)")
        .call(d3.svg.axis().scale(yScale).orient(axisOrient).ticks(5))
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", axisOrient === "right" ? -10 : 12)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .style("fill", meta.stroke)
        .text(meta.unit || "");

      const line = d3.svg
        .line()
        .x((d) => xScale(d.timestamp))
        .y((_d, idx) => yScale(values[idx]))
        .interpolate("monotone");

      svg
        .append("path")
        .datum(series)
        .attr("fill", "none")
        .attr("stroke", meta.stroke)
        .attr("stroke-width", 1)
        .attr("d", line);
    });

    // Legend
    const legend = d3.select(el).append("div").attr("class", "dacom-allbrush__legend");
    station.meta.forEach((meta) => {
      const label = `${(meta.key || "").replace("__depths__", " ")} (${meta.unit || ""})`;
      const entry = legend.append("span").attr("class", "dacom-allbrush__legend-item");
      entry.append("span").attr("class", "dacom-allbrush__swatch").style("background", meta.stroke);
      entry.append("span").text(label);
    });

    return () => {
      d3.select(el).selectAll("*").remove();
    };
  }, [station]);

  return <div ref={containerRef} className="dacom-allbrush" />;
};

export default AllBrush;
